import { useCallback } from 'react'

import { useCookies as _useCookies } from 'react-cookie'

const defaultOptions = {
  secure: window.location.protocol === 'https:',
  sameSite: 'Strict',
  path: '/',
}

export const useCookies = (_dependencies = []) => {
  const [cookies, _setCookie, _removeCookie] = _useCookies(_dependencies)

  const setCookie = useCallback(
    (cookieName, cookieData, options = {}) => {
      _setCookie(cookieName, cookieData, { ...defaultOptions, ...options })
    },
    [_setCookie],
  )

  const removeCookie = useCallback(
    (cookieName, options = {}) => {
      _removeCookie(cookieName, { ...defaultOptions, ...options })
    },
    [_removeCookie],
  )

  return [cookies, setCookie, removeCookie]
}

export default useCookies
